import React from 'react';
import './AdPriceSelector.scss';

interface AdPriceObject {
    standard: string,
    premium: string
}
declare const adPriceObject: AdPriceObject;

export default function AdPriceSelector({ setAdPrice, setJourney }) {
    return (
        <>
            <h3 className="form-h3">Choose your ad level</h3>
            <div className="form-tile-selector">
                <div className="ad-type__selector" onClick={() => { setAdPrice('Premium'); setJourney('adtype') }}>
                    <h2 className="ad-type__heading">Premium</h2>
                    <ul className="ad-type__benefit">
                        <li>1 x premium ad listing</li>
                        <li>Appears for 6 weeks</li>
                        <li>Highlighted design</li>
                    </ul>
                    <div className="ad-type__price">
                        £{adPriceObject.premium}.00 <span className="ad-type__vat">+ VAT</span>
                    </div>
                </div>
                <div className="ad-type__selector" onClick={() => { setAdPrice('Standard'); setJourney('adtype') }}>
                    <h2 className="ad-type__heading">Standard</h2>
                    <ul className="ad-type__benefit">
                        <li>1 x standard ad listing</li>
                        <li>Appears for 2 weeks</li>
                        <li>Appears as a standard listing</li>
                    </ul>
                    <div className="ad-type__price">
                        £{adPriceObject.standard}.00 <span className="ad-type__vat">+ VAT</span>
                    </div>
                </div>
            </div>
        </>
    )
}
